// MARK: NPM Modules
import React from "react";
import styled from "styled-components";
// MARK: Components
import Link from "components/common/links/standard";

// MARK: Styled Components
interface ContainerProps {
  height: string;
  margin: number;
  backgroundcolor: string;
  transition?: string;
  mobile: boolean;
  maxWidth?: number;
}

const Container = styled.header<ContainerProps>`
  
  width: 100vw;
  height: ${({ height }) => height};
  transition: ${({ transition }) => (transition ? transition : "0s")};
  
  margin: auto;
  background-color: ${({ backgroundcolor }) => backgroundcolor};
  overflow: hidden;
  z-index: 100;

  @media (max-width: 768px) {
    display: ${({ mobile }) => mobile ? "" : "none"};
    padding-left: ${({ margin }) => margin}px;
    padding-right: ${({ margin }) => margin}px;
  }

  @media (min-width: 769px) and (max-width: 1439px) {
    display: ${({ mobile }) => mobile ? "none" : ""};
    padding-left: ${({ margin }) => margin}px;
    padding-right: ${({ margin }) => margin}px;
  }

  @media (min-width: 1440px) {
    display: ${({ mobile }) => mobile ? "none" : ""};
    max-width: ${({ maxWidth }) => maxWidth ? maxWidth + "px" : ""}; 
  }
`;

interface IdentityProps {
  dimension: number;
}

const Identity = styled(({ padding, ...props }) => (
  <Link {...props} />
))<IdentityProps>`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: ${({ dimension }) => (dimension ? dimension : 0)}px;
  height: ${({ dimension }) => (dimension ? dimension : 0)}px;
`;

const LogoContainer = styled.div`
  width: 40px;
  height: 40px;
`;

interface NavProps {
  margin?: number;
  height?: string;
  top?: string;
  position?: string;
}

const Nav = styled.nav<NavProps>`
  position: ${({ position }) => (position ? position : "")};
  width: 100%;
  top: ${({ top }) => (top ? top : "")};
  height: ${({ height }) => (height ? height : "100%")};
  margin-left: ${({ margin }) => margin}px;
`;

export default Container;
export { Container, Identity, LogoContainer, Nav };
